module.exports = __webpack_public_path__ + "static/media/i-bitz.0fd7cbf1.png";